import Layout from '@/components/feature/Layout';
import SEOHead from '@/components/base/SEOHead';
import { localBusinessSchema, buildBreadcrumbSchema, buildGraphSchema } from '@/components/base/schemas';
import HeroSection from './components/HeroSection';
import TeamSection from './components/TeamSection';
import ServicesSection from './components/ServicesSection';
import WhyUsSection from './components/WhyUsSection';
import StatsSection from './components/StatsSection';
import ZonesSection from './components/ZonesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const breadcrumbSchema = buildBreadcrumbSchema([
  { name: 'Accueil', item: 'https://fenetre-paris15.fr/' },
]);

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'Quel est le délai d\'intervention de DF PRO dans Paris 15 ?', acceptedAnswer: { '@type': 'Answer', text: 'DF PRO intervient dans tout le 15ᵉ arrondissement sous 24 à 48h après votre appel. Pour les urgences, nous faisons notre maximum pour nous déplacer le jour même.' } },
    { '@type': 'Question', name: 'Quels sont vos tarifs pour une réparation de fenêtre ?', acceptedAnswer: { '@type': 'Answer', text: 'Nos tarifs varient selon la nature de la panne. Nous pratiquons le prix fixe après diagnostic. Le changement d\'une poignée se situe généralement entre 80€ et 200€.' } },
    { '@type': 'Question', name: 'Intervenez-vous sur toutes les marques de fenêtres ?', acceptedAnswer: { '@type': 'Answer', text: 'Oui, nos techniciens sont formés pour intervenir sur l\'ensemble des fabricants : Ferco, Roto, Maco, Winkhaus, Siegenia, Somfy, Bubendorff, Profalux, etc.' } },
    { '@type': 'Question', name: 'Le devis est-il vraiment gratuit et sans engagement ?', acceptedAnswer: { '@type': 'Answer', text: 'Oui, le devis est entièrement gratuit et sans engagement. Le déplacement reste gratuit même si vous refusez le devis.' } },
    { '@type': 'Question', name: 'Proposez-vous une garantie sur vos réparations ?', acceptedAnswer: { '@type': 'Answer', text: 'Toutes nos interventions sont garanties, pièces et main-d\'œuvre. DF PRO est assuré en responsabilité civile professionnelle.' } },
  ],
};

const fullSchema = buildGraphSchema(localBusinessSchema, breadcrumbSchema, faqSchema);

export default function HomePage() {
  return (
    <Layout>
      <SEOHead
        title="Réparation Fenêtre Paris 15 — Devis Gratuit 24/48h | DF PRO"
        description="Réparation fenêtres PVC, alu, bois, volets roulants et baies vitrées dans le 15ᵉ (75015). Intervention 24/48h, devis gratuit. ☎ 01 87 66 81 55"
        canonicalUrl="https://fenetre-paris15.fr/"
        schema={fullSchema}
      />
      <HeroSection />
      <TeamSection />
      <ServicesSection />
      <WhyUsSection />
      <StatsSection />
      <ZonesSection />
      <TestimonialsSection />
      <FaqSection />
      <CtaSection />
    </Layout>
  );
}